APP.Bind = (/** @lends APP.Bind */function () {
	'use strict';

	var exports = {},
		$body,
		events = ['click', 'change', 'blur', 'focus', 'keyup'],
		eventMap = {};

	function init() {
		initDOMElements();
		initBindings();
	}

	function initDOMElements() {
		$body = APP.Performance.getCachedDOM().$body;
	}

	function initBindings() {
		var i;

		for (i = 0; i < events.length; i++) {
			createBind(events[i]);
			$body.on(events[i], '[data-' + events[i] + ']', callEvent(events[i]));
		}
	}

	function callEvent(eventName) {
		return function (event) {
			var $this = $(this),
				binderAttributes = $this.attr('data-' + eventName).split(';'),
				i,
				methodName,
				methodArgument;

			for(i = 0; i < binderAttributes.length; i++) {
				methodName = binderAttributes[i].split(':')[0];
				methodArgument = binderAttributes[i].substr(methodName.length + 1);

				if (eventMap.hasOwnProperty(eventName)) {
					if (eventMap[eventName].hasOwnProperty(methodName)) {
						eventMap[eventName][methodName](event, methodArgument);
					}
				}
			}
		};
	}

	function createBind(eventName) {
		exports[eventName] = function (map) {
			var key,
				mapObject = map;

			if (typeof map !== 'object') {
				// if for example: APP.Bind.Click('a', b)
				mapObject = {};
				mapObject[arguments[0]] = arguments[1];
			}

			eventMap[eventName] = eventMap[eventName] || {};
			for (key in mapObject) {
				if (mapObject.hasOwnProperty(key)) {
					eventMap[eventName][key] = mapObject[key];
				}
			}

		};
	}

	function trigger(eventName, element){
		callEvent(eventName).apply(element);
	}

	/**
	 * Example dom use:
	 *  <a data-click="subscribe:{listName:businessNewsLetter}">click here to subscribe</a>
	 *
	 * Example event binding:
	 *  APP.Bind.click({
	 *      'subscribe' : function(event, arguments){
	 *          event.preventDefault();
	 *          if(arguments.listName === 'businessNewsLetter') {
	 *              subscribeToBusinessNewsLetter();
	 *          } else {
	 *              subscribeToUserNewsLetter();
	 *          }
	 *      }
	 * });
	 */

	exports.init = init;
	exports.trigger = trigger;
	return exports;

}());

